


















import { Component, Prop, Vue } from 'vue-property-decorator'
import { TriggeredAction } from '@/api/model/triggered-action'

@Component
export default class CreateAutoActionVerticalStep2 extends Vue {
    @Prop({ required: true }) readonly currentStep!: number
    @Prop({ default: false }) readonly existing!: boolean
    @Prop({ required: true }) readonly value!: TriggeredAction

    get triggerTypeLabel() {
        if (this.value.triggerType === 'appointment') {
            return this.$t('forms.triggered_action_form.trigger_type_options.appointment')
        } else {
            return this.$t(`forms.triggered_action_form.trigger_type_options.change-${this.value.changedField}`)
        }
    }

    get changedFieldValueLabel() {
        if (this.value.changedField === 'status') {
            return this.statusTranslation
        } else if (this.value.changedField === 'phase') {
            return this.phaseTranslation
        }

        return '-'
    }

    get statusTranslation() {
        if (!this.value.changedFieldValue) {
            return '-'
        }

        return this.$t(`referral.phaseModelStatus.${this.value.changedFieldValue}`)
    }

    get phaseTranslation() {
        if (!this.value.changedFieldValue) {
            return '-'
        }

        const phaseChangedFieldValue = this.value.referralPipeline.phases
            .find(phase => phase.id  === this.value.changedFieldValue)

        return phaseChangedFieldValue?.name || '-'
    }
}
